import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";

import pesasImage from "../../static/media/Home/pesas.webp";
import crosfitImage from "../../static/media/Home/crosfit.webp";
import hidratacionImage from "../../static/media/Home/hidratacion.webp";
import webImage from "../../static/media/Home/web.webp";
import cardioImage from "../../static/media/Home/cardio.webp";
import camerinosImage from "../../static/media/Home/camerinos.webp";

const features = [
  {
    title: "Área de pesas",
    description:
      "Entrena con equipos y espacio pensado para desarrollar fuerza con comodidad y enfoque.",
    image: pesasImage,
  },
  {
    title: "Crossfit",
    description:
      "Zona dinámica para sesiones intensas y funcionales dentro de NovaXFit.",
    image: crosfitImage,
  },
  {
    title: "Zona de hidratación",
    description:
      "Espacio práctico para recargar energía y mantener tu rendimiento.",
    image: hidratacionImage,
  },
  {
    title: "App web para registro",
    description:
      "Accede a tu cuenta y gestiona tu experiencia de forma rápida y digital.",
    image: webImage,
  },
  {
    title: "Zona de cardio",
    description:
      "Entrenamientos enfocados en resistencia y movimiento en un ambiente cómodo.",
    image: cardioImage,
  },
  {
    title: "Camerinos",
    description:
      "Espacios funcionales para una mejor experiencia antes y después de entrenar.",
    image: camerinosImage,
  },
];

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

const itemVariants = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      ease: "easeOut",
    },
  },
};

export default function GymFeaturesSection() {
  return (
    <Box
      component="section"
      sx={{
        width: "100%",
        py: { xs: 5, md: 7 },
        bgcolor: "#ffffff",
      }}
    >
      <Box
        sx={{
          width: { xs: "90%", md: "85%" },
          mx: "auto",
          textAlign: "center",
        }}
      >
        <Box sx={{ mb: { xs: 4, md: 5 } }}>
          <Typography
            sx={{
              color: "#e50914",
              fontWeight: 800,
              fontSize: 13,
              mb: 1.5,
            }}
          >
            TODO LO QUE ENCONTRARÁS EN NOVAXFIT
          </Typography>

          <Typography
            sx={{
              color: "#111",
              fontWeight: 800,
              fontSize: {
                xs: "clamp(28px,6vw,36px)",
                md: "clamp(36px,3vw,48px)",
              },
              lineHeight: 1.05,
              mb: 1.5,
            }}
          >
            Espacios creados para tu mejor rendimiento
          </Typography>

          <Typography
            sx={{
              color: "rgba(17,17,17,0.75)",
              fontSize: { xs: 15, md: 16 },
              lineHeight: 1.7,
            }}
          >
            Conoce todo lo que NovaXFit tiene para ofrecerte.
          </Typography>
        </Box>
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <Grid
            container
            spacing={{ xs: 3, md: 4 }}
            justifyContent="center"
          >
            {features.map((feature) => (
              <Grid item xs={12} sm={6} md={4} key={feature.title}>
                <motion.div variants={itemVariants}>
                  <Box
                    sx={{
                      width: "100%",
                      maxWidth: 260,
                      mx: "auto",
                      textAlign: "center",
                    }}
                  >
                    <Box
                      component={motion.img}
                      src={feature.image}
                      alt={feature.title}
                      initial={{ scale: 0.85, opacity: 0 }}
                      whileInView={{ scale: 1, opacity: 1 }}
                      viewport={{ once: true }}
                      transition={{ duration: 0.5 }}
                      sx={{
                        width: 110,
                        height: 110,
                        objectFit: "contain",
                        mb: 1.5,
                      }}
                    />

                    <Typography
                      sx={{
                        color: "#111",
                        fontWeight: 800,
                        fontSize: 18,
                        mb: 0.6,
                      }}
                    >
                      {feature.title}
                    </Typography>

                    <Typography
                      sx={{
                        display: { xs: "none", sm: "block" },
                        color: "rgba(17,17,17,0.7)",
                        fontSize: 14.5,
                        lineHeight: 1.6,
                      }}
                    >
                      {feature.description}
                    </Typography>
                  </Box>
                </motion.div>
              </Grid>
            ))}
          </Grid>
        </motion.div>
      </Box>
    </Box>
  );
}